import {
  ArrowForwardRounded,
  BadgeOutlined,
  FamilyRestroomOutlined,
  SchoolOutlined,
} from "@mui/icons-material";
import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import { getSettings } from "apis/controllers/common";
import background from "assets/images/login-background.png";
import {
  LandingProgramInfo2025,
  LandingProgramInfo2026,
  ProgramInfoYearSwitch,
  useProgramInfoYear,
} from "pages/ProgramInfo/ProgramInfoContent";
import UnderConstruction from "pages/UnderConstruction";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  setSelectedProgramDataKey,
  toProgramDataKey,
} from "util/programSelection";
import "./LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { programInfoYear, isProgramInfo2026, setProgramInfoYear } =
    useProgramInfoYear();

  const handleCitizenLogin = (programNumber) => {
    setSelectedProgramDataKey(toProgramDataKey(programNumber));
    navigate(`/pubnr/program-${programNumber}/login`);
  };

  const handleEmployeeLogin = () => {
    navigate("/govnr/login");
  };

  const fetchSettings = async () => {
    try {
      const res = await getSettings();
      const getValue = (key) =>
        res.data.find((d) => d.dataKey === key)?.dataValue;
      setSettings({
        project_pubnr_login_enabled:
          getValue("project_pubnr_login_enabled") === "true",
        project_under_construction:
          getValue("project_under_construction") === "true",
        project_pubnr_login_disabled_msg: getValue(
          "project_pubnr_login_disabled_msg",
        ),
        project_under_construction_msg: getValue(
          "project_under_construction_msg",
        ),
      });
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (window.location.pathname === "/lae-miteres") {
      window.history.replaceState({}, "", "/lae-miteres/");
    }
    fetchSettings();
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const programInfoSwitch = (
    <ProgramInfoYearSwitch
      value={programInfoYear}
      onChange={setProgramInfoYear}
    />
  );

  return settings?.project_under_construction ? (
    <UnderConstruction msg={settings?.project_under_construction_msg} />
  ) : (
    <div
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "70vh",
        width: "100%",
        marginTop: "-18px",
      }}
    >
      <div className="landing-content">
        {isProgramInfo2026 ? (
          <LandingProgramInfo2026 yearSwitch={programInfoSwitch} />
        ) : (
          <LandingProgramInfo2025 yearSwitch={programInfoSwitch} />
        )}

        <section
          className="landing-actions"
          aria-labelledby="landing-actions-title"
        >
          <div className="landing-program-actions">
            <Tooltip title={settings?.project_pubnr_login_disabled_msg || ""}>
              <span className="landing-program-action-wrapper">
                <Button
                  className="landing-program-action landing-program-action--five"
                  disabled={!settings?.project_pubnr_login_enabled}
                  onClick={() => handleCitizenLogin(5)}
                  startIcon={<FamilyRestroomOutlined />}
                  endIcon={<ArrowForwardRounded />}
                  aria-label="Είσοδος για πολίτες για το Πρόγραμμα 5"
                >
                  <span className="landing-program-action__content">
                    <span className="landing-program-action__title">
                      Πρόγραμμα χρηματικών βοηθημάτων - βραβείων σε τρίτεκνες
                      και πολύτεκνες οικογένειες
                    </span>
                    <span className="landing-program-action__description">
                      Είσοδος για πολίτες
                    </span>
                  </span>
                </Button>
              </span>
            </Tooltip>

            <Tooltip title={settings?.project_pubnr_login_disabled_msg || ""}>
              <span className="landing-program-action-wrapper">
                <Button
                  className="landing-program-action landing-program-action--six"
                  disabled={!settings?.project_pubnr_login_enabled}
                  onClick={() => handleCitizenLogin(6)}
                  startIcon={<SchoolOutlined />}
                  endIcon={<ArrowForwardRounded />}
                  aria-label="Είσοδος για πολίτες για το Πρόγραμμα 6"
                >
                  <span className="landing-program-action__content">
                    {/* <span className="landing-program-action__number">
                      Πρόγραμμα 6
                    </span> */}
                    <span className="landing-program-action__title">
                      Πρόγραμμα χρηματικών βραβείων - υποτροφιών σε
                      επιτυχόντες/ούσες μαθητές/τριες στις πανελλαδικές
                      εξετάσεις 2026
                    </span>
                    <span className="landing-program-action__description">
                      Είσοδος για πολίτες
                    </span>
                  </span>
                </Button>
              </span>
            </Tooltip>
          </div>

          <div className="landing-employee-action">
            <span>Για εξουσιοδοτημένους χρήστες</span>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<BadgeOutlined />}
              onClick={handleEmployeeLogin}
            >
              Είσοδος για υπαλλήλους
            </Button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default LandingPage;
